import * as React from 'react';
import ReactDOM from 'react-dom';

export default function asyncRender(node: JSX.Element, container: HTMLElement): Promise<void> {
    return new Promise<void>(function(resolve: any, reject: any) {
        function onMount() {
            setTimeout(resolve, 0);
        }
        function Component() {
            React.useEffect(onMount, []);
            return node;
        }
        try {
            ReactDOM.render(<Component />, container);
        } catch (error) {
            reject(error);
        }
    });
}
